<div class="container trivia-leaderboard-container">
  <fgb-upgrade-banner></fgb-upgrade-banner>
  <fgb-leaderboard [toShow]="20" [LeaderboardType]="LeaderboardType"></fgb-leaderboard>
</div>
